import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { withTranslation } from 'react-i18next';
import { isEmpty } from 'lodash';
import moment from 'moment';
import PageTitle from '../../../../components/PageTitle';
import RouteNames from '../../../App/RouteNames';
import TitleFrom from '../../../../components/common/TitleFrom';
import { uploadMultiPartFiles, saveOutputTemplateByType, getOutputTemplateByType } from '../../../App/actions';
import { AccountReportSearchForm } from '../../../../components/ReportHub';
import {
  SwitchExport,
  DataTable,
  ExcelExport,
  TablePagination,
  ButtonExport,
  EmailGroup,
  DragDropConfigExportTemplate,
  ModalWithItem,
} from '../../../../components/common';
import { tabelColumnExportAccountReport, sortAccountReport } from '../../constants';
import { getReportAccountReport, getAllListAccountReport } from '../../actions';
import { makeGetListAccountReport, makeGetListAllAccountReport } from '../../selectors';
import {
  getPageTotalCount,
  parseToMutationRequestPostMethod,
  blobToFile,
  validateEmail,
  blobToCSVFile,
  configOutputTemplateByType,
} from '../../../../utils/utils';
import convertJson2Sheet from '../../../../utils/ExcelHelper/exportExcelFile';
import convertJson2Pdf from '../../../../utils/PdfHelper/exportPdfFile';
import { PAGE_SIZE_DOWNLOAD } from '../../../../utils/constants';

let tableColumnsOutput = null;

class AccountReport extends Component {
  state = {
    isActivePdf: false,
    page: 0,
    size: 20,
    filter: {},
    sort: '',
    sorted: {},
    totalCount: null,
    isSearching: false,
    listAccountReports: [],
    emails: [],
  };

  buttonRef = React.createRef();

  static getDerivedStateFromProps(props, state) {
    return {
      listAccountReports: props.listAccountReports,
      totalCount: getPageTotalCount({ ...state, items: props.listAccountReports }),
    };
  }

  componentDidMount() {
    const {
      permissions: { modeSearchAccountReport },
    } = this.props;
    if (modeSearchAccountReport) {
      this.doGetReportAccountReport();
      this.doGetOutputTemplateByType();
    }
  }

  onSortColumn = (sortCol, sortDir) => {
    this.setState({ sorted: { sortCol, sortDir } }, () => {
      this.doGetReportAccountReport();
    });
  };

  onPageChange = page => {
    this.setState({ page }, () => this.doGetReportAccountReport());
  };

  onSizeChange = size => {
    this.setState({ size, page: 0 }, () => this.doGetReportAccountReport());
  };

  onHandleSubmitSearch = filter => {
    this.setState({ filter: { ...filter }, page: 0 }, () => {
      this.doGetReportAccountReport();
    });
  };

  doGetReportAccountReport = () => {
    const { filter, page, size, sorted } = this.state;
    const { getReportAccountReport } = this.props;
    const payload = {
      page: page + 1,
      size,
      filter,
      sort: !isEmpty(sorted) ? sortAccountReport[sorted.sortCol][sorted.sortDir] : null,
    };
    this.setState({ isSearching: true });
    getReportAccountReport(payload, () => {
      this.setState({ isSearching: false });
    });
  };

  doGetAllAccountReport = cb => {
    const { filter, sorted } = this.state;
    const { getAllListAccountReport } = this.props;
    const payload = {
      page: 1,
      size: PAGE_SIZE_DOWNLOAD,
      filter,
      sort: !isEmpty(sorted) ? sortAccountReport[sorted.sortCol][sorted.sortDir] : null,
    };
    getAllListAccountReport(payload, () => {
      if (cb) cb();
    });
  };

  onChangeSwitch = () => {
    const { isActivePdf } = this.state;
    this.setState({ isActivePdf: !isActivePdf });
  };

  onExport = () => {
    this.doGetAllAccountReport(() => {
      const { isActivePdf } = this.state;
      if (isActivePdf) {
        const { listAllAccountReport, t } = this.props;
        convertJson2Pdf({
          data: listAllAccountReport,
          t,
          title: t('reportPage:sidebar.accountReport').toLocaleUpperCase(),
          fileName: `${t('reportPage:sidebar.accountReport')
            .toLocaleLowerCase()
            .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`,
          columnsTable: tableColumnsOutput,
          fontSize: 4,
        });
      } else {
        this.buttonRef.current.click();
      }
    });
  };

  sendEmail = ({ subject, emailBody }) => {
    this.doGetAllAccountReport(() => {
      const { listAllAccountReport, t, uploadMultiPartFiles } = this.props;
      const { emails, isActivePdf } = this.state;
      const query = `{"query": "mutation{sendReport(input: ${parseToMutationRequestPostMethod(
        {
          emailAddress: emails.join(', '),
          type: 'SEARCH_ACCOUNT_REPORT',
          subject: subject || `Embrix Report ${t('reportPage:sidebar.accountReport')}`,
          emailBody,
        },
        ['type']
      )})}"}`;

      const formData = new FormData();
      formData.append('graphql', query);
      if (!isActivePdf) {
        formData.append(
          'file',
          blobToCSVFile({
            fileName: `${t('reportPage:sidebar.accountReport')
              .toLocaleLowerCase()
              .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}.csv`,
            data: listAllAccountReport,
            t,
            columns: tableColumnsOutput,
            listOptionFields: { accountType: 'accountType' },
          })
        );
      } else {
        const pdfFile = convertJson2Pdf({
          data: listAllAccountReport,
          t,
          title: t('reportPage:sidebar.accountReport').toLocaleUpperCase(),
          fileName: `${t('reportPage:sidebar.accountReport')
            .toLocaleLowerCase()
            .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`,
          isFile: true,
          columnsTable: tableColumnsOutput,
          fontSize: 4,
        });
        formData.append(
          'file',
          blobToFile(
            pdfFile,
            `${t('reportPage:sidebar.accountReport')
              .toLocaleLowerCase()
              .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`
          )
        );
      }
      uploadMultiPartFiles(
        formData,
        res => {
          if (res && res.success) {
            if (res.success) this.setState({ emails: [] });
          }
        },
        true
      );
    });
  };

  onChangeEmail = tags => {
    let isEmail = true;
    if (tags && tags.length) {
      tags.forEach(email => {
        if (!validateEmail(email)) {
          isEmail = false;
        }
      });
    }
    if (!isEmail) return '';

    return this.setState({ emails: tags });
  };

  doGetOutputTemplateByType = () => {
    const { getOutputTemplateByType, t } = this.props;
    getOutputTemplateByType('ACCOUNTS_REPORT', ({ success, data }) => {
      if (success && data) {
        this.setState({
          exportColumnsSave: configOutputTemplateByType({
            columns: tabelColumnExportAccountReport,
            data,
            t,
          }),
          idOutputTemplate: data?.id,
          typeOutputTemplate: data?.type,
        });
      }
    });
  };

  onHandleSaveConfig = columns => {
    const { saveOutputTemplateByType } = this.props;
    const { idOutputTemplate, typeOutputTemplate } = this.state;
    const payload = {
      id: idOutputTemplate,
      type: typeOutputTemplate,
      source: columns.sourceFields.items.map((val, index) => {
        return { name: val.name, index: index + 1 };
      }),
      target: columns.targetFields.items.map((val, index) => {
        return { name: val.name, index: index + 1 };
      }),
    };

    saveOutputTemplateByType(payload, ({ success }) => {
      if (success) {
        this.doGetOutputTemplateByType();
        this.setState({ exportColumnsSave: columns, isOpenModalExportConfig: false });
      }
    });
  };

  onToggleModalExportConfig = () => {
    const { isOpenModalExportConfig } = this.state;
    this.setState({ isOpenModalExportConfig: !isOpenModalExportConfig });
  };

  render() {
    const {
      isSearching,
      isActivePdf,
      sorted,
      page,
      size,
      totalCount,
      listAccountReports,
      emails,
      isOpenModalExportConfig,
      exportColumnsSave,
    } = this.state;
    const {
      listAllAccountReport,
      t,
      permissions: { modeSearchAccountReport, modeDownloadReport, modeGetMailReport },
    } = this.props;
    if (!modeSearchAccountReport) return '';

    const exportColumns = exportColumnsSave || {};
    tableColumnsOutput = exportColumns?.targetFields?.items || [];
    return (
      <div className="col-md-12">
        <PageTitle
          linkTo={RouteNames.report.path}
          titleBtn="back"
          items={[
            { name: t('label.report'), url: RouteNames.report.path },
            { name: t('reportPage:sidebar.accountReport') },
          ]}
        />
        <br />
        <div className="card card-statistics mb-30">
          <TitleFrom title={t('reportPage:sidebar.accountReport')} />
          <div className="col-md-12 mb-30">
            <div className="card-body">
              <div className="pl-2">
                <AccountReportSearchForm onSubmit={this.onHandleSubmitSearch} />
              </div>
              <div>
                <div className="mt-3 row mb-4 pt-3 pb-3">
                  <button
                    type="submit"
                    onClick={this.onToggleModalExportConfig}
                    className="button x-small mr-2 btn-config"
                  >
                    {/* {t('label.outputConfig')} */}
                    <i className="ti-list" />
                  </button>
                  {!!modeDownloadReport && (
                    <div className="ml-auto mt-2 mb-auto mr-3">
                      <SwitchExport
                        onChange={this.onChangeSwitch}
                        wrapperClass={isActivePdf ? 'switch-active' : 'switch-non-active'}
                        title={t('label.excel')}
                        checked={isActivePdf}
                        rightTitle={t('label.pdf')}
                      />
                    </div>
                  )}
                  {!!modeDownloadReport && (
                    <>
                      <ButtonExport onExport={this.onExport} />
                      <ExcelExport
                        element={<button type="button" className="display-none" ref={this.buttonRef} />}
                        nameSheet={t('reportPage:sidebar.accountReport').toLocaleUpperCase()}
                        multiDataSet={convertJson2Sheet({
                          data: listAllAccountReport,
                          t,
                          title: t('reportPage:sidebar.accountReport').toLocaleUpperCase(),
                          columnsTable: tableColumnsOutput,
                        })}
                        fileName={`${t('reportPage:sidebar.accountReport')
                          .toLocaleLowerCase()
                          .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`}
                      />
                    </>
                  )}
                  {modeGetMailReport !== 0 && (
                    <EmailGroup
                      emails={emails}
                      onChangeEmail={this.onChangeEmail}
                      sendEmail={this.sendEmail}
                      data={listAccountReports}
                    />
                  )}
                </div>
                <DataTable
                  columns={tableColumnsOutput}
                  data={listAccountReports && listAccountReports.length ? listAccountReports : []}
                  onSort={this.onSortColumn}
                  sorted={sorted}
                  isLoading={isSearching}
                  isFixedHeaderTable
                />
              </div>
            </div>
          </div>
        </div>
        <div className="mb-30">
          <TablePagination
            pageNumber={page}
            pageSize={size}
            totalCount={totalCount}
            onPageChange={this.onPageChange}
            onSizeChange={this.onSizeChange}
          />
        </div>
        <ModalWithItem
          onToggle={this.onToggleModalExportConfig}
          isOpen={isOpenModalExportConfig}
          wrapperClass="modal-config"
        >
          <div className="col-md-12 d-flex">
            <div className="column-config" onClick={this.onToggleModalExportConfig} />
            <div className="body-config">
              <DragDropConfigExportTemplate
                onHandleSave={this.onHandleSaveConfig}
                exportColumns={exportColumns}
                onToggle={this.onToggleModalExportConfig}
              />
            </div>
          </div>
        </ModalWithItem>
      </div>
    );
  }
}

AccountReport.propTypes = {};

AccountReport.defaultProps = {};

const mapStateToProps = createStructuredSelector({
  listAccountReports: makeGetListAccountReport() || [],
  listAllAccountReport: makeGetListAllAccountReport() || [],
});
export default withTranslation('common')(
  connect(mapStateToProps, {
    getReportAccountReport,
    getAllListAccountReport,
    uploadMultiPartFiles,
    saveOutputTemplateByType,
    getOutputTemplateByType,
  })(AccountReport)
);
